import styled from 'styled-components';

export const Content = styled.div`
  img {
    cursor: pointer;
    &:last-child {
      margin-left: 30px;
    }
  }
`;
